"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Phase4 = Phase4;
require("core-js/modules/es.promise.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _greenTick = require("../assets/green-tick.svg");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _PhaserGame = require("../tutorial-game/PhaserGame");
var _EventBus = require("../tutorial-game/EventBus");
var _blockSelector = _interopRequireDefault(require("../block-selector-4"));
var _ontouchcog = require("../assets/blocks/ontouchcog.svg");
var _forward = require("../assets/blocks/forward.svg");
var _backward = require("../assets/blocks/backward.svg");
var _jump = require("../assets/blocks/jump.svg");
var _selectedBlocksFromTutorial = require("../utils/selected-blocks-from-tutorial");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const posterItems = [{
  icon: _forward.ReactComponent,
  block: "moveforward",
  execute: async () => true
}, {
  icon: _backward.ReactComponent,
  block: "movebackward",
  execute: async () => true
}, {
  icon: _jump.ReactComponent,
  block: "jump",
  execute: async () => true
}];
const staticBlockItem = {
  icon: _ontouchcog.ReactComponent,
  block: "ontouchcog",
  execute: async () => true
};
function Phase4(_ref) {
  let {
    nextPhase
  } = _ref;
  const [gameContainerDimensions, setGameContainerDimensions] = (0, _react.useState)({
    width: "40vw",
    height: "30vh",
    visibility: "hidden"
  });
  const [isSceneReady, setIsSceneReady] = (0, _react.useState)(false);
  const [tickIconState, setTickIconState] = (0, _react.useState)("hidden");
  const [blocksIconState, setBlocksIconState] = (0, _react.useState)("visible");
  const phaserGameRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    _EventBus.EventBus.on('sky-ready', sky => {
      const skyHeightScaled = sky.height * sky.scaleFactors.height;
      const skyWidthScaled = sky.width * sky.scaleFactors.width;
      sky.scene.shouldPlayGhostAnimation = true;
      setGameContainerDimensions({
        width: skyWidthScaled + "px",
        height: skyHeightScaled + "px",
        visibility: "visible"
      });
    });
    _EventBus.EventBus.on('current-scene-ready', scene => {
      //@ts-ignore
      window.scene = scene;
      setTimeout(() => {
        var _scene$player, _scene$sky, _scene$sky2, _scene$stars, _scene$stars2;
        scene.physics.world.setBounds(0, 0, scene.scale.width, scene.scale.height);
        (_scene$player = scene.player) === null || _scene$player === void 0 || _scene$player.setCollideWorldBounds(true);
        scene.spawnStar();
        const skyWidthScaled = (_scene$sky = scene.sky) === null || _scene$sky === void 0 ? void 0 : _scene$sky.scaleFactors.width;
        const skyHeightScaled = (_scene$sky2 = scene.sky) === null || _scene$sky2 === void 0 ? void 0 : _scene$sky2.scaleFactors.height;
        Phaser.Actions.SetX(((_scene$stars = scene.stars) === null || _scene$stars === void 0 ? void 0 : _scene$stars.getChildren()) || [], 700 * (skyWidthScaled || 1));
        Phaser.Actions.SetY(((_scene$stars2 = scene.stars) === null || _scene$stars2 === void 0 ? void 0 : _scene$stars2.getChildren()) || [], 400 * (skyHeightScaled || 1));
      }, 1000);
      setIsSceneReady(true);
    });
    _EventBus.EventBus.on('star-collected', () => {
      setTimeout(() => {
        var _phaserGameRef$curren, _phaserGameRef$curren2;
        setBlocksIconState("animation");
        (_phaserGameRef$curren = phaserGameRef.current) === null || _phaserGameRef$curren === void 0 || (_phaserGameRef$curren = _phaserGameRef$curren.game) === null || _phaserGameRef$curren === void 0 || _phaserGameRef$curren.destroy(true);
        (0, _selectedBlocksFromTutorial.setSelectedBlockFromTutorialForJump)(((_phaserGameRef$curren2 = phaserGameRef.current) === null || _phaserGameRef$curren2 === void 0 || (_phaserGameRef$curren2 = _phaserGameRef$curren2.scene) === null || _phaserGameRef$curren2 === void 0 ? void 0 : _phaserGameRef$curren2.currentlySectedBlock) || null);
      }, 1500);
    });
    return () => {
      _EventBus.EventBus.removeListener('star-collected');
      _EventBus.EventBus.removeListener('sky-ready');
      _EventBus.EventBus.removeListener('current-scene-ready');
      _EventBus.EventBus.removeListener('player-jumped');
    };
  }, []);
  const onDummyClick = (0, _react.useCallback)(() => {
    var _phaserGameRef$curren3, _phaserGameRef$curren4;
    setBlocksIconState("animation");
    (_phaserGameRef$curren3 = phaserGameRef.current) === null || _phaserGameRef$curren3 === void 0 || (_phaserGameRef$curren3 = _phaserGameRef$curren3.game) === null || _phaserGameRef$curren3 === void 0 || _phaserGameRef$curren3.destroy(true);
    (0, _selectedBlocksFromTutorial.setSelectedBlockFromTutorialForJump)(((_phaserGameRef$curren4 = phaserGameRef.current) === null || _phaserGameRef$curren4 === void 0 || (_phaserGameRef$curren4 = _phaserGameRef$curren4.scene) === null || _phaserGameRef$curren4 === void 0 ? void 0 : _phaserGameRef$curren4.currentlySectedBlock) || null);
  }, []);
  const onBlocksAnimationEnd = (0, _react.useCallback)(() => {
    setBlocksIconState("hidden");
    setTickIconState("animation");
  }, []);
  const onTickIconAnimationEnd = (0, _react.useCallback)(() => {
    nextPhase();
  }, []);
  const blocksIconContainerClasses = [_stylesModule.default.doubleColumnContainer, blocksIconState === "animation" ? _stylesModule.default.fadeOutAnimation : "", blocksIconState === "hidden" ? _stylesModule.default.hide : ""].join(" ");
  const tickIconClassNames = [_stylesModule.default.tickIconFullScreen, tickIconState === "animation" ? _stylesModule.default.fadeInAnimation : "", tickIconState === "hidden" ? _stylesModule.default.hide : "", tickIconState === "visible" ? _stylesModule.default.show : ""].join(" ");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.singleColumnContainer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: blocksIconContainerClasses,
      onAnimationEnd: onBlocksAnimationEnd,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.blockSelectorContainer,
        children: isSceneReady && /*#__PURE__*/(0, _jsxRuntime.jsx)(_blockSelector.default, {
          gameRef: phaserGameRef,
          posterItems: posterItems,
          staticBlockItem: staticBlockItem,
          staticBlock: "jump"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.gameContainer,
        style: gameContainerDimensions,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PhaserGame.PhaserGame, {
          ref: phaserGameRef
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_greenTick.ReactComponent, {
      className: tickIconClassNames,
      onAnimationEnd: onTickIconAnimationEnd
    })]
  });
}